'use client';

import React, { useEffect } from 'react';

import { useRouter } from 'next/navigation';

import { useLanguage } from '@lib/hooks';

type NotFoundErrorProps = {};

const NotFoundError: React.FC<NotFoundErrorProps> = () => {
  const { replace } = useRouter();
  const lng = useLanguage();

  useEffect(() => {
    replace(`/${lng}`);
  }, [replace, lng]);

  return (
    <html>
      <body></body>
    </html>
  );
};

export default NotFoundError;
